import { ComparisonTable, useQueryParams } from '@insurancemenu/imenu-components-lib';
import { filterByPLinAndDisabledStatus } from '@insurancemenu/imenu-components-lib/dist/components/ComparisonTable/utils';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import FormsSpinner from 'components/common/loaders/FormSpinner';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useRootStore } from 'store/rootStore';
import { ComparisonPageType } from 'store/ui-stores/comparison/comparisonStore';
import { createStyles } from './styles';

export interface ComparisonContentProps {
  type: ComparisonPageType;
}

const ElectionComparisonContent = observer(({ type }: ComparisonContentProps): JSX.Element => {
  const classes = createStyles();
  const query = useQueryParams();

  const cartId = query.get('cartId') || '';
  const productLineId = query.get('productLineId') || '';
  const portfolioId = query.get('portfolioId') || '';
  const portfolioIds = query.get('portfolioIds') || '';
  const productIds = query.get('productIds') || '';
  const periodId = query.get('periodId') || '';
  const eeClass = query.get('eeClass') || '';

  const {
    comparisonStore: {
      loading,
      filteredPortfolios,
      cart,
      marketingTags,
      productLineAttrs,
      loaderInPortfolioId,
      collectInitialData,
    },
  } = useRootStore();

  const convertedFilteredPortfolios = filteredPortfolios.map((portfolio) => toJS(portfolio)).slice();
  const convertedMarketingTags = marketingTags.map((tag) => toJS(tag)).slice();
  const convertedProductLineAttrs = productLineAttrs.map((attr) => toJS(attr)).slice();
  const convertedCart = toJS(cart);
  const convertedProductLineId = (productLineId as ProductLineId) || convertedCart.cartItems[0].productLineId;

  useEffect(() => {
    if (productLineId && cartId) {
      void collectInitialData({
        cartId,
        productLineId: convertedProductLineId,
        type,
        portfolioId,
        portfolioIds,
        productIds,
        periodId,
        eeClass,
      });
    }
  }, [productLineId, cartId]);

  // Filter by product line id and product disabled status
  const filteredOutDisabledProducts = filterByPLinAndDisabledStatus(
    convertedFilteredPortfolios,
    convertedProductLineId,
    true,
  );

  return (
    <div className={classes.content}>
      <>
        {loading ? (
          <FormsSpinner display={loading} />
        ) : (
          <>
            {convertedFilteredPortfolios.length > 0 && (
              <ComparisonTable
                containerStyles={
                  filteredOutDisabledProducts.length === 0 ? classes.emptyTableContent : classes.tableContent
                }
                portfolios={convertedFilteredPortfolios}
                marketingTags={convertedMarketingTags}
                productLineAttributes={convertedProductLineAttrs}
                loading={loading}
                productLineId={convertedProductLineId}
                loaderInPortfolioId={loaderInPortfolioId}
                //  Hide browsing criteria block
                lastUpdateBcShortName=""
                cartItems={[]}
              />
            )}
          </>
        )}
      </>
    </div>
  );
});

export default ElectionComparisonContent;
